module.exports = __webpack_public_path__ + "img/red-icon.0d74cf4c.png";